import { AText, Box } from '@alf/uikit';
import { LocalizedLink } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';

import styles from './index.module.css';

export const SecondarySubMenuItems = ({ items = [] }) =>
  items.map(
    ({ id, link, title, icon, isPrimary }) =>
      (title || icon) && (
        <Box
          data-role={id}
          key={id}
          align="center"
          justify="between"
          className={styles.secondMenuItem}
        >
          <LocalizedLink to={link} className={styles.subItems}>
            {icon && <Icon name={`icons/general/nav/${icon}`} size="m" />}
            {title && (
              <AText
                size={isPrimary ? 'm' : 's'}
                breed={isPrimary ? 'BU' : 'R'}
              >
                {title}
              </AText>
            )}
          </LocalizedLink>
        </Box>
      )
  );
